import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { SizeProp } from '@fortawesome/angular-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

import {
    FieldInterventionContextConfig,
    FieldInterventionContextState,
} from '@connect-services/client/services/add-layer.service';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-field-intervention-context-icon',
    templateUrl: './field-intervention-context-icon.component.html',
})
export class FieldInterventionContextIconComponent {
    public readonly config = input.required<FieldInterventionContextConfig>();
    public readonly contextClick = output<void>();
    public readonly size = input<SizeProp>('lg');

    protected readonly cursor = computed(() => {
        return this.config().disabled ? 'default' : 'pointer';
    });
    protected readonly icon = computed<IconProp>(() => {
        return this.config().state === FieldInterventionContextState.EXCLUDED
            ? ['far', 'mobile-slash']
            : ['far', 'mobile'];
    });
    protected readonly isInherited = computed(() => {
        return this.config().state === FieldInterventionContextState.INHERITED;
    });
    protected readonly tooltip = computed(() => {
        return this.config().tooltip ?? '';
    });

    protected onClick(): void {
        if (this.config().disabled) {
            return;
        }

        this.contextClick.emit();
    }
}
